<template>
  <div class="main-container dark bg-with-image">
    <app-header />
    <div class="container h-100">

      <!-- Not found / invalid status -->
      <div v-if="!isKnownStatus">
        <div class="card mx-md-5 h-100 d-flex flex-column align-items-center justify-content-center">
          <h1 class="mb-2 text-center">Pesquisa de satisfação</h1>
          <h5 class="text-center">Pesquisa não encontrada!</h5>
        </div>
      </div>

      <!-- Expired -->
      <div v-else-if="status === csatStatus.EXPIRED">
        <div class="card mx-md-5 h-100 d-flex flex-column align-items-center justify-content-center">
          <h1 class="mb-2 text-center">Pesquisa de satisfação</h1>
          <h5 class="text-center">Seu prazo para responder a pesquisa expirou!</h5>
        </div>
      </div>

      <!-- Already answered -->
      <div v-else-if="status === csatStatus.ANSWERED">
        <div class="card mx-md-5 h-100 d-flex flex-column align-items-center justify-content-center">
          <h1 class="mb-2 text-center">Pesquisa de satisfação</h1>
          <h5 class="text-center">Essa pesquisa já foi respondida!</h5>
        </div>
      </div>

      <!-- Pending -->
      <div v-else>
        <div class="card mx-md-5 h-100 d-flex flex-column align-items-center justify-content-center">
          <h1 class="mb-2 text-center">Pesquisa de satisfação</h1>

          <!-- Intro -->
          <div class="text-center mb-3" v-if="form.intro && form.intro.length">
            <p v-for="(line, i) in form.intro" :key="i" class="mb-1">{{ line }}</p>
          </div>

          <!-- Target name -->
          <div class="mb-4 text-center" v-if="targetName">
            <small class="text-muted">Para: {{ targetName }}</small>
          </div>

          <!-- Question -->
          <label class="text-question form-label text-center mb-2">
            {{ form.question }}
          </label>

          <!-- Stars (required >= 1) -->
          <div class="text-center mb-4">
            <!-- If you have a Stars component, use it. Otherwise keep simple buttons -->
            <StarsRating
              v-if="hasStarsComponent"
              v-model="score"
              :min="form.scale.min"
              :max="form.scale.max"
              :required="true"
            />
            <template v-else>
              <input
                v-for="num in range(form.scale.min, form.scale.max)"
                :key="num"
                type="button"
                :value="num"
                :class="['value-recom mb-1', { active: score === num }, { 'is-invalid': showScoreError }]"
                @click="score = num"
              />
            </template>
            <div class="invalid-feedback text-start" v-if="showScoreError">
              Você deve informar uma pontuação
            </div>
          </div>

          <!-- Optional text -->
          <div v-if="form.optional_text_field.enabled" class="mb-4 w-100">
            <label class="text-center text-question form-label">
              {{ form.optional_text_field.label }}
            </label>
            <textarea
              v-model="text"
              class="form-control"
              :placeholder="form.optional_text_field.placeholder"
              rows="4"
            />
          </div>

          <button class="btn btn-orange" :disabled="loading" @click="submit">
            {{ loading ? 'Enviando...' : 'Finalizar' }}
          </button>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import AppHeader from '../../main/components/AppHeader';
import * as types from '../store/types';
import * as csatStatus from '@/constants/csatStatusTypes';
// import StarsRating from '@/components/StarsRating.vue' // if you have it

export default {
  components: { AppHeader /*, StarsRating*/ },
  data() {
    return {
      loading: false,
      score: null,
      text: '',
      hasStarsComponent: false, // flip to true if you import your shared stars component
    };
  },
  computed: {
    ...mapGetters({ csatSurvey: types.CSAT_SURVEY }),
    status() { return this.csatSurvey?.status; },
    form() {
      return this.csatSurvey?.form ?? {
        intro: [],
        question: 'Como você avalia esta experiência?',
        scale: { min: 1, max: 5, type: 'stars', labels: {} },
        optional_text_field: { enabled: true, label: 'Comentário (opcional)', placeholder: '' },
      };
    },
    targetName() { return this.csatSurvey?.target?.name ?? null; },
    csatStatus() { return csatStatus; },
    isKnownStatus() {
      return [csatStatus.PENDING, csatStatus.ANSWERED, csatStatus.EXPIRED].includes(this.status);
    },
    showScoreError() { return this.score === null; },
  },
  async mounted() {
    await this.getCsatSurvey(this.$route.params.token); // keep same route param style as NPS
  },
  methods: {
    ...mapActions({
      getCsatSurvey: types.GET_CSAT_SURVEY,
      setCsatSurvey: types.SET_CSAT_SURVEY,
    }),
    range(min, max) { return Array.from({ length: (max - min + 1) }, (_, i) => i + min); },
    async submit() {
      if (this.score === null) {
        // visually mark invalid
        return;
      }
      this.loading = true;
      try {
        await this.setCsatSurvey({
          idOrToken: this.$route.params.token,
          score: this.score,
          text: this.text?.trim() || null,
        });
        window.location.reload();
      } catch (e) {
        this.$vfm?.show?.('message', {
          type: 'error',
          messages: [
            'Não foi possível finalizar a pesquisa.',
            'Entre em contato com o time de TI.',
          ],
        });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.text-question { font-style: italic; }

.value-recom {
  border-color: #fff; border-radius: 10px; padding: 10px 20px;
  background: #fff !important; color: #3253a8 !important; font-weight: 700;
  margin-right: 0.5rem;
  &:last-child { margin-right: 0; }
}

.active {
  background: linear-gradient(225deg, rgba(253,75,75,1) 50%, rgba(232,122,36,1) 100%) !important;
  color: #fff !important;
}

.btn-orange { font-weight: 700 !important; font-size: 1rem; }

@media (max-width: 575.98px) {
  .h-100 { height: auto !important; }
  #header { position: absolute; }
}
</style>
